export default __webpack_public_path__ + "locales/nl/Payments.json?hash=2c795fb0fa28f50c3545a4180501411b";